import { render, staticRenderFns } from "./LoadingAlert.vue?vue&type=template&id=188d88be&"
import script from "./LoadingAlert.vue?vue&type=script&lang=js&"
export * from "./LoadingAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports